import React from "react";
import Warning from "../../components/Warning";
import DeleteEklokContainer from "../../containers/ekloks/DeleteEklokContainer";

const Delete = ({ eklok, handleClose = () => {}, open }) => {
  return (
    <DeleteEklokContainer eklok={eklok} handleClose={handleClose}>
      {({ onSubmit }) => (
        <Warning
          openWarning={open}
          message="Confirm the action?"
          onCloseConfirm={onSubmit}
          onCloseCancel={handleClose}
        />
      )}
    </DeleteEklokContainer>
  );
};

export default Delete;
